import { memo } from 'react';
import classNames from 'classnames';

import config, { isEnabled } from 'Config';

import { ViewportSmartImage } from 'Containers/SmartImage';
import { I13nAnchor } from 'Components/I13n';

import { commonLinkStyle } from 'Styles/sharedStyle';

type Props = {
  'data-testid': string;
  buttonClassName?: string;
  href: string;
  image: string;
  imageClassName?: string;
  intlMessage: string;
  itemProp: string;
  message: string;
};

const crossMediaConversion = {
  isCrossMedia: true,
  allow_custom_scripts: true,
  send_to: `${config.gCrossMediaFloodlightID}/convert/download+standard`,
};

const AppLink = (props: Props) => {
  const {
    buttonClassName,
    href,
    image,
    intlMessage,
    itemProp,
    message,
    imageClassName,
    'data-testid': testid = 'AppLink',
  } = props;

  return (
    <I13nAnchor
      className={classNames(buttonClassName, commonLinkStyle, 'My(0) P(0) D(ib)')}
      href={href}
      i13nModel={{ conversion: crossMediaConversion, message }}
      data-testid={testid}
      itemProp={itemProp}
    >
      <ViewportSmartImage
        aria-hidden
        alt=""
        className={classNames('Objf(ct) Maw(100%)', imageClassName)}
        urls={[image]}
        transformWebp={isEnabled('webp')}
      />
      <span className="Hidden">{intlMessage}</span>
    </I13nAnchor>
  );
};

export default memo(AppLink);
